import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IDaylightCardLinkProps } from "./DaylightCardLink.props";

export const DaylightCardLink = ({ children, className, link }: IDaylightCardLinkProps) => {
  const classes = cn(
    "group block transition-[background-color,border-color,filter] duration-200 ease-out",
    link &&
      "hover:brightness-[0.98] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
    className,
  );

  if (!link) return <article className={classes}>{children}</article>;

  const Link = getComponent("Link");
  return (
    <Link
      aria-label={link.accessibilityLabel || undefined}
      className={classes}
      href={link.href}
      rel={link.openInNewTab ? "noopener noreferrer" : undefined}
      target={link.openInNewTab ? "_blank" : undefined}
    >
      {children}
    </Link>
  );
};

DaylightCardLink.displayName = "Content::DaylightCardLink";
